const STORAGE_KEY = "tesourinhos_mock_payments_v1";

function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return [];
  }
}

function loadAll() {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return Array.isArray(safeParse(raw)) ? safeParse(raw) : [];
}

function saveAll(transactions) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(transactions));
}

function makeId(prefix = "mock") {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function computeTotal(items = []) {
  return items.reduce((acc, item) => {
    const price = Number(item.preco ?? item.valor ?? 0);
    const quantity = Number(item.quantidade ?? 1);
    return acc + price * quantity;
  }, 0);
}

export function createMockTransaction({ userId, userEmail, items, paymentMethod }) {
  const transactions = loadAll();
  const now = new Date().toISOString();
  const transaction = {
    id: makeId("tx"),
    provider: "mock",
    status: "pendente",
    paymentMethod: paymentMethod || "pix",
    userId,
    userEmail: userEmail || null,
    items: items || [],
    total: computeTotal(items),
    createdAt: now,
    updatedAt: now,
  };

  transactions.unshift(transaction);
  saveAll(transactions);
  return transaction;
}

export function listMockTransactions(userId) {
  return loadAll()
    .filter((tx) => tx.userId === userId)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export function updateMockTransactionStatus(transactionId, status) {
  const transactions = loadAll();
  const next = transactions.map((tx) =>
    tx.id === transactionId
      ? { ...tx, status, updatedAt: new Date().toISOString() }
      : tx,
  );
  saveAll(next);
  return next.find((tx) => tx.id === transactionId) || null;
}
